import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Esperando al electricista que nunca llega a horario', 'Pagando $25.000 por un enchufe que se cambia en 20 minutos', 'Sin saber qué hacer cuando salta la térmica a las 2 AM', 'Tablero sin etiquetar donde nadie sabe qué controla cada palanca', 'Diferencial que salta solo y nadie explica por qué', 'Aire acondicionado conectado en el circuito incorrecto desde hace años', 'Miedo a tocar cualquier cosa porque "la electricidad es peligrosa"'];
export function PainSection() {
  return <section className="py-14 relative overflow-hidden" data-id="element-231">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9IiMzMzMiLz48L3N2Zz4=')] opacity-20" data-id="element-232"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center mb-10" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-235">
            ¿Cuántos fines de semana más vas a esperar al electricista?
          </h2>
          <p className="text-lg text-textsecondary" data-id="element-236">
            Querés resolver los problemas de tu casa pero terminás dependiendo
            de alguien que llega tarde, cobra lo que quiere y no te explica
            nada.
            <br data-id="element-237" />
            <br data-id="element-238" />
            <span className="text-white font-medium" data-id="element-239">
              No es falta de capacidad. Es falta de un sistema.
            </span>
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto grid gap-4 md:grid-cols-2" data-id="element-240">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum p-5 rounded-xl border border-red-500/10 flex items-start gap-4 hover:border-red-500/30 transition-colors" data-id="element-241">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-242" />
              <span className="text-textsecondary" data-id="element-243">{pain}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-10" data-id="element-244">
          <h3 className="text-2xl md:text-3xl font-bold text-electric" data-id="element-245">
            ¿Y si este fuera el último fin de semana que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}